import {
  UserOutlined,
  // MessageOutlined,
  BellOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
  LockOutlined
} from '@ant-design/icons';
import { Tabs, Button, Select  }                                                                        from 'antd';
import React, {useState}                                                                                   from 'react';
import "./Settings.scss";
// import ContactSupport
//                                                                                                from './contactSupport/contactSupport';
import DeactOrDelete
                                                                                               from './DeactOrDelete/DeactOrDelete';
import Faqs                                                                                    from './FAQS/faqs';
import MyProfile
                                                                                               from './myProfile/myProfile';
import Notifications
                         from './notifications/notifications';
import { useNavigate } from 'react-router-dom';
import RenterProfile
                                                                                               from './RenterProfile/RenterProfile';

const {Option} = Select

const Settings = () => {
  const [value, setValue] = useState("1");
  const navigation = useNavigate()
  let leftItems = [
    {
      key: "1",
      label: `My Profile`,
      children: value === "1" && <MyProfile/>,
      icon: <UserOutlined/>
    },
    {
      key: "2",
      label: `Renter Profile`,
      children:value === "2" && <RenterProfile/>,
      icon: <UserOutlined/>
    },
    {
      key: "3",
      label: `De-activate or delete account`,
      children: <DeactOrDelete/>,
      icon: <DeleteOutlined/>
    },
    {
      key: "4",
      label: `FAQ's`,
      children: <Faqs/>,
      icon: <QuestionCircleOutlined/>
    },
    // {
    //   key: "5",
    //   label: `Contact Support`,
    //   children: <ContactSupport/>,
    //   icon: <MessageOutlined/>
    // },
    {
      key: "6",
      label: `Notifications`,
      children: <Notifications/>,
      icon: <BellOutlined/>
    }
    ,
    {
      key: "7",
      label: <Button
        onClick={()=>navigation("/newPassword")}
        style={{
        width:"100%"
      }} icon={<LockOutlined />}  type={"primary"}>Reset Password</Button>,
      disabled: true,
    }
  ]

  const handleChange = (value) => {
    setValue(value);
  };

  return <div className={ "settingsContainer" }>
    <Tabs
      className={"forDesktop"}
      style={{
        paddingTop:"5%"
      }}
      defaultActiveKey={"1"}
      items={ leftItems }
      tabPosition={ "left" }
      onChange={handleChange}
      />
    <div  className={"forMobile"} style={{
      paddingTop:76,
      width:"90%",
      margin:"auto"
    }}>
    <Select
      defaultValue="1"
      value={value}
      style={{ width: "100%"}}
      onChange={handleChange}
      placeholder={"Select Option"}
    >
      {
        leftItems.map(item=><Option value={item.key}>{item.label}</Option>)
      }
    </Select>
    </div>

    <Tabs
      className={"forMobile"}
      activeKey={value}
      // onChange={setActiveKey}
      tabBarStyle={{ display: "none" }} // Hide the tab bar
    >
      {leftItems.map((item) => (
        <Tabs.TabPane key={item.key} tab={item.label}>
          {item.children}
        </Tabs.TabPane>
      ))}
    </Tabs>
  </div>
}

export default Settings